const colorArray = ["#DA3812", "#F99A02", "#2F69CC", "#129219", "#FB3F06", '#0DD5A4', '#a9a9a9']; //print, digital, tv, radio, emarald, light grey
export const mediaLineColorArray = ["#FB3102", "#FFBF58", "#3C7BE5", "#08CD10"];
export const overviewTileLineColorArray = [
  "#E43CCA",
  "#FFBF58",
  "#18B58C",
  "#FB3102",
];
export const articleLineColorArray = [
  "#E53CCA",
  "#FFBF58",
  "#3E7BE5",
  "#E52D02",
];

export default colorArray;
